import { TableColumn } from '@app/components/common/table';

export type ColumnsOptions = {
  type: EntityBase[];
};

export const useColumns = () => {
  return [
    {
      name: 'id',
      label: '#',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'name',
      label: 'Название',
      options: {
        filter: true,
        sort: true,
      },
    },
  ] as TableColumn[];
};
